import React from 'react';
import { Col, Icon, message, Popconfirm, Row, Switch } from 'antd';



class ActionBox extends React.Component {
    render() {

        const { 
            active,
        } = this.props;

        return(
            <Row type="flex" justify="space-between">
            <Col 
                className="edit-featured-category"
                onClick={this.onEdit}
                span={8} 
                >
                Edit  <Icon type="edit" />
            </Col> 
            
            <Col 
                span={4}
                >
                <Popconfirm 
                    cancelText="No"
                    title="Are you sure you want to permanently remove this category?" 
                    onConfirm={this.onDelete} 
                    okText="Yes" 
                    >
                    <Icon 
                        className="delete-featured-category"
                        type="delete" />
                </Popconfirm>
                
            </Col> 

            <Col className="active-switch" 
            span={5}>
                <Switch 
                    size="small" 
                    defaultChecked={active} 
                    onChange={(e) => this.toggleActive(e)}
                    />
            </Col>
        </Row>
        )
    }

    onDelete = () => {
        this.props.onDelete(this.props.position)
        message.success("Category deleted")
    }
    onEdit = () => {
        this.props.onEdit(this.props.position)
    }
    
    toggleActive = () => {
        this.props.toggleActive(this.props.position)
    }


}

export default ActionBox;



// WEBPACK FOOTER //
// ./src/components/featured/sortable-featured-list/action-box.js